var cov_247ndtjkpl = function () {
  var path = "/Users/spana/SHEIN/shineout/src/hoc/hidable.tsx",
      hash = "aeae8da6cad2c86a1553140bde422146a2bba243",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/hoc/hidable.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 16
        },
        end: {
          line: 10,
          column: 61
        }
      },
      "1": {
        start: {
          line: 12,
          column: 25
        },
        end: {
          line: 16,
          column: 1
        }
      },
      "2": {
        start: {
          line: 14,
          column: 43
        },
        end: {
          line: 16,
          column: 1
        }
      },
      "3": {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 15,
          column: 82
        }
      },
      "4": {
        start: {
          line: 15,
          column: 30
        },
        end: {
          line: 15,
          column: 62
        }
      },
      "5": {
        start: {
          line: 39,
          column: 22
        },
        end: {
          line: 39,
          column: 51
        }
      },
      "6": {
        start: {
          line: 40,
          column: 24
        },
        end: {
          line: 40,
          column: 52
        }
      },
      "7": {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 53,
          column: 18
        }
      },
      "8": {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 57,
          column: 7
        }
      },
      "9": {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 58,
          column: 21
        }
      },
      "10": {
        start: {
          line: 59,
          column: 6
        },
        end: {
          line: 59,
          column: 44
        }
      },
      "11": {
        start: {
          line: 63,
          column: 6
        },
        end: {
          line: 63,
          column: 31
        }
      },
      "12": {
        start: {
          line: 64,
          column: 17
        },
        end: {
          line: 64,
          column: 34
        }
      },
      "13": {
        start: {
          line: 65,
          column: 6
        },
        end: {
          line: 65,
          column: 21
        }
      },
      "14": {
        start: {
          line: 65,
          column: 15
        },
        end: {
          line: 65,
          column: 21
        }
      },
      "15": {
        start: {
          line: 67,
          column: 6
        },
        end: {
          line: 67,
          column: 52
        }
      },
      "16": {
        start: {
          line: 67,
          column: 23
        },
        end: {
          line: 67,
          column: 52
        }
      },
      "17": {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 72,
          column: 7
        }
      },
      "18": {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 70,
          column: 19
        }
      },
      "19": {
        start: {
          line: 71,
          column: 8
        },
        end: {
          line: 71,
          column: 14
        }
      },
      "20": {
        start: {
          line: 74,
          column: 6
        },
        end: {
          line: 74,
          column: 31
        }
      },
      "21": {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 79,
          column: 7
        }
      },
      "22": {
        start: {
          line: 77,
          column: 8
        },
        end: {
          line: 77,
          column: 36
        }
      },
      "23": {
        start: {
          line: 78,
          column: 8
        },
        end: {
          line: 78,
          column: 31
        }
      },
      "24": {
        start: {
          line: 83,
          column: 6
        },
        end: {
          line: 83,
          column: 52
        }
      },
      "25": {
        start: {
          line: 83,
          column: 46
        },
        end: {
          line: 83,
          column: 52
        }
      },
      "26": {
        start: {
          line: 85,
          column: 6
        },
        end: {
          line: 86,
          column: 22
        }
      },
      "27": {
        start: {
          line: 85,
          column: 27
        },
        end: {
          line: 85,
          column: 38
        }
      },
      "28": {
        start: {
          line: 86,
          column: 11
        },
        end: {
          line: 86,
          column: 22
        }
      },
      "29": {
        start: {
          line: 90,
          column: 6
        },
        end: {
          line: 90,
          column: 65
        }
      },
      "30": {
        start: {
          line: 94,
          column: 17
        },
        end: {
          line: 94,
          column: 40
        }
      },
      "31": {
        start: {
          line: 95,
          column: 6
        },
        end: {
          line: 95,
          column: 26
        }
      },
      "32": {
        start: {
          line: 96,
          column: 6
        },
        end: {
          line: 109,
          column: 12
        }
      },
      "33": {
        start: {
          line: 97,
          column: 8
        },
        end: {
          line: 108,
          column: 9
        }
      },
      "34": {
        start: {
          line: 98,
          column: 10
        },
        end: {
          line: 98,
          column: 39
        }
      },
      "35": {
        start: {
          line: 100,
          column: 10
        },
        end: {
          line: 107,
          column: 11
        }
      },
      "36": {
        start: {
          line: 101,
          column: 12
        },
        end: {
          line: 101,
          column: 42
        }
      },
      "37": {
        start: {
          line: 103,
          column: 12
        },
        end: {
          line: 106,
          column: 24
        }
      },
      "38": {
        start: {
          line: 104,
          column: 14
        },
        end: {
          line: 104,
          column: 32
        }
      },
      "39": {
        start: {
          line: 105,
          column: 14
        },
        end: {
          line: 105,
          column: 30
        }
      },
      "40": {
        start: {
          line: 113,
          column: 6
        },
        end: {
          line: 113,
          column: 36
        }
      },
      "41": {
        start: {
          line: 114,
          column: 22
        },
        end: {
          line: 114,
          column: 39
        }
      },
      "42": {
        start: {
          line: 116,
          column: 6
        },
        end: {
          line: 124,
          column: 7
        }
      },
      "43": {
        start: {
          line: 117,
          column: 8
        },
        end: {
          line: 117,
          column: 42
        }
      },
      "44": {
        start: {
          line: 118,
          column: 8
        },
        end: {
          line: 118,
          column: 49
        }
      },
      "45": {
        start: {
          line: 119,
          column: 8
        },
        end: {
          line: 119,
          column: 41
        }
      },
      "46": {
        start: {
          line: 121,
          column: 8
        },
        end: {
          line: 123,
          column: 14
        }
      },
      "47": {
        start: {
          line: 122,
          column: 10
        },
        end: {
          line: 122,
          column: 38
        }
      },
      "48": {
        start: {
          line: 126,
          column: 6
        },
        end: {
          line: 130,
          column: 18
        }
      },
      "49": {
        start: {
          line: 127,
          column: 8
        },
        end: {
          line: 129,
          column: 9
        }
      },
      "50": {
        start: {
          line: 128,
          column: 10
        },
        end: {
          line: 128,
          column: 40
        }
      },
      "51": {
        start: {
          line: 134,
          column: 22
        },
        end: {
          line: 134,
          column: 45
        }
      },
      "52": {
        start: {
          line: 135,
          column: 6
        },
        end: {
          line: 137,
          column: 7
        }
      },
      "53": {
        start: {
          line: 136,
          column: 8
        },
        end: {
          line: 136,
          column: 39
        }
      },
      "54": {
        start: {
          line: 138,
          column: 24
        },
        end: {
          line: 142,
          column: 7
        }
      },
      "55": {
        start: {
          line: 143,
          column: 23
        },
        end: {
          line: 143,
          column: 51
        }
      },
      "56": {
        start: {
          line: 144,
          column: 6
        },
        end: {
          line: 148,
          column: 7
        }
      },
      "57": {
        start: {
          line: 152,
          column: 2
        },
        end: {
          line: 152,
          column: 49
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 12,
            column: 25
          },
          end: {
            line: 12,
            column: 26
          }
        },
        loc: {
          start: {
            line: 14,
            column: 43
          },
          end: {
            line: 16,
            column: 1
          }
        },
        line: 14
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 14,
            column: 43
          },
          end: {
            line: 14,
            column: 44
          }
        },
        loc: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 15,
            column: 82
          }
        },
        line: 15
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 15,
            column: 21
          },
          end: {
            line: 15,
            column: 22
          }
        },
        loc: {
          start: {
            line: 15,
            column: 30
          },
          end: {
            line: 15,
            column: 62
          }
        },
        line: 15
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 35,
            column: 15
          },
          end: {
            line: 35,
            column: 16
          }
        },
        loc: {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 153,
            column: 1
          }
        },
        line: 38
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        },
        loc: {
          start: {
            line: 52,
            column: 26
          },
          end: {
            line: 60,
            column: 5
          }
        },
        line: 52
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        },
        loc: {
          start: {
            line: 62,
            column: 24
          },
          end: {
            line: 80,
            column: 5
          }
        },
        line: 62
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 82,
            column: 5
          }
        },
        loc: {
          start: {
            line: 82,
            column: 37
          },
          end: {
            line: 87,
            column: 5
          }
        },
        line: 82
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 89,
            column: 4
          },
          end: {
            line: 89,
            column: 5
          }
        },
        loc: {
          start: {
            line: 89,
            column: 17
          },
          end: {
            line: 91,
            column: 5
          }
        },
        line: 89
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 93,
            column: 5
          }
        },
        loc: {
          start: {
            line: 93,
            column: 11
          },
          end: {
            line: 110,
            column: 5
          }
        },
        line: 93
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 96,
            column: 17
          },
          end: {
            line: 96,
            column: 18
          }
        },
        loc: {
          start: {
            line: 96,
            column: 23
          },
          end: {
            line: 109,
            column: 7
          }
        },
        line: 96
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 103,
            column: 23
          },
          end: {
            line: 103,
            column: 24
          }
        },
        loc: {
          start: {
            line: 103,
            column: 29
          },
          end: {
            line: 106,
            column: 13
          }
        },
        line: 103
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 112,
            column: 4
          },
          end: {
            line: 112,
            column: 5
          }
        },
        loc: {
          start: {
            line: 112,
            column: 11
          },
          end: {
            line: 131,
            column: 5
          }
        },
        line: 112
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 121,
            column: 19
          },
          end: {
            line: 121,
            column: 20
          }
        },
        loc: {
          start: {
            line: 121,
            column: 25
          },
          end: {
            line: 123,
            column: 9
          }
        },
        line: 121
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 126,
            column: 17
          },
          end: {
            line: 126,
            column: 18
          }
        },
        loc: {
          start: {
            line: 126,
            column: 23
          },
          end: {
            line: 130,
            column: 7
          }
        },
        line: 126
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 133,
            column: 5
          }
        },
        loc: {
          start: {
            line: 133,
            column: 13
          },
          end: {
            line: 149,
            column: 5
          }
        },
        line: 133
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 37,
            column: 19
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 37,
            column: 11
          },
          end: {
            line: 37,
            column: 19
          }
        }],
        line: 37
      },
      "1": {
        loc: {
          start: {
            line: 37,
            column: 21
          },
          end: {
            line: 37,
            column: 35
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 37,
            column: 32
          },
          end: {
            line: 37,
            column: 35
          }
        }],
        line: 37
      },
      "2": {
        loc: {
          start: {
            line: 37,
            column: 37
          },
          end: {
            line: 37,
            column: 54
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 37,
            column: 47
          },
          end: {
            line: 37,
            column: 54
          }
        }],
        line: 37
      },
      "3": {
        loc: {
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 65,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 65,
            column: 21
          }
        }, {
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 65,
            column: 21
          }
        }],
        line: 65
      },
      "4": {
        loc: {
          start: {
            line: 67,
            column: 6
          },
          end: {
            line: 67,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 67,
            column: 6
          },
          end: {
            line: 67,
            column: 52
          }
        }, {
          start: {
            line: 67,
            column: 6
          },
          end: {
            line: 67,
            column: 52
          }
        }],
        line: 67
      },
      "5": {
        loc: {
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 72,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 72,
            column: 7
          }
        }, {
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 72,
            column: 7
          }
        }],
        line: 69
      },
      "6": {
        loc: {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 79,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 79,
            column: 7
          }
        }, {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 79,
            column: 7
          }
        }],
        line: 76
      },
      "7": {
        loc: {
          start: {
            line: 83,
            column: 6
          },
          end: {
            line: 83,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 83,
            column: 6
          },
          end: {
            line: 83,
            column: 52
          }
        }, {
          start: {
            line: 83,
            column: 6
          },
          end: {
            line: 83,
            column: 52
          }
        }],
        line: 83
      },
      "8": {
        loc: {
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 86,
            column: 22
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 86,
            column: 22
          }
        }, {
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 86,
            column: 22
          }
        }],
        line: 85
      },
      "9": {
        loc: {
          start: {
            line: 97,
            column: 8
          },
          end: {
            line: 108,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 97,
            column: 8
          },
          end: {
            line: 108,
            column: 9
          }
        }, {
          start: {
            line: 97,
            column: 8
          },
          end: {
            line: 108,
            column: 9
          }
        }],
        line: 97
      },
      "10": {
        loc: {
          start: {
            line: 100,
            column: 10
          },
          end: {
            line: 107,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 100,
            column: 10
          },
          end: {
            line: 107,
            column: 11
          }
        }, {
          start: {
            line: 100,
            column: 10
          },
          end: {
            line: 107,
            column: 11
          }
        }],
        line: 100
      },
      "11": {
        loc: {
          start: {
            line: 116,
            column: 6
          },
          end: {
            line: 124,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 116,
            column: 6
          },
          end: {
            line: 124,
            column: 7
          }
        }, {
          start: {
            line: 116,
            column: 6
          },
          end: {
            line: 124,
            column: 7
          }
        }],
        line: 116
      },
      "12": {
        loc: {
          start: {
            line: 127,
            column: 8
          },
          end: {
            line: 129,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 127,
            column: 8
          },
          end: {
            line: 129,
            column: 9
          }
        }, {
          start: {
            line: 127,
            column: 8
          },
          end: {
            line: 129,
            column: 9
          }
        }],
        line: 127
      },
      "13": {
        loc: {
          start: {
            line: 127,
            column: 12
          },
          end: {
            line: 127,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 127,
            column: 12
          },
          end: {
            line: 127,
            column: 37
          }
        }, {
          start: {
            line: 127,
            column: 41
          },
          end: {
            line: 127,
            column: 48
          }
        }],
        line: 127
      },
      "14": {
        loc: {
          start: {
            line: 135,
            column: 6
          },
          end: {
            line: 137,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 135,
            column: 6
          },
          end: {
            line: 137,
            column: 7
          }
        }, {
          start: {
            line: 135,
            column: 6
          },
          end: {
            line: 137,
            column: 7
          }
        }],
        line: 135
      },
      "15": {
        loc: {
          start: {
            line: 139,
            column: 46
          },
          end: {
            line: 139,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 139,
            column: 46
          },
          end: {
            line: 139,
            column: 61
          }
        }, {
          start: {
            line: 139,
            column: 65
          },
          end: {
            line: 139,
            column: 71
          }
        }],
        line: 139
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

var _this = this,
    _jsxFileName = "/Users/spana/SHEIN/shineout/src/hoc/hidable.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import createReactContext from '../context';
import { PureComponent } from '../component';
import { getUidStr } from '../utils/uid';
import { hidableClass } from './styles';
var context = (cov_247ndtjkpl.s[0]++, createReactContext({}));
cov_247ndtjkpl.s[1]++;
export var consumer = function consumer(Origin) {
  cov_247ndtjkpl.f[0]++;
  cov_247ndtjkpl.s[2]++;
  return function (props) {
    cov_247ndtjkpl.f[1]++;
    cov_247ndtjkpl.s[3]++;
    return (
      /*#__PURE__*/
      React.createElement(context.Consumer, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 15,
          columnNumber: 3
        }
      }, function (value) {
        cov_247ndtjkpl.f[2]++;
        cov_247ndtjkpl.s[4]++;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, value, props, {
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 15,
              columnNumber: 31
            }
          }))
        );
      })
    );
  };
};

/**
 * @param {*} Component
 * @param {*} duration
 * @param {*} type - fade, collapse, tranlate
 */
export default function (Component, _ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? (cov_247ndtjkpl.b[0][0]++, ['fade']) : _ref$type,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? (cov_247ndtjkpl.b[1][0]++, 360) : _ref$duration,
      _ref$display = _ref.display,
      display = _ref$display === void 0 ? (cov_247ndtjkpl.b[2][0]++, 'block') : _ref$display;
  cov_247ndtjkpl.f[3]++;
  var hasCollapse = (cov_247ndtjkpl.s[5]++, type.indexOf('collapse') >= 0);
  var needTransform = (cov_247ndtjkpl.s[6]++, type.indexOf('scale-y') >= 0);

  var Hidable =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(Hidable, _PureComponent);

    var _super = _createSuper2(Hidable);

    function Hidable(props) {
      var _this2;

      _classCallCheck(this, Hidable);

      cov_247ndtjkpl.f[4]++;
      cov_247ndtjkpl.s[7]++;
      _this2 = _super.call(this, props);
      _this2.height = void 0;
      _this2.id = void 0;
      cov_247ndtjkpl.s[8]++;
      _this2.state = {
        show: props.show
      };
      cov_247ndtjkpl.s[9]++;
      _this2.height = 0;
      cov_247ndtjkpl.s[10]++;
      _this2.id = "__hidable_".concat(getUidStr(), "__");
      return _this2;
    }

    _createClass(Hidable, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        cov_247ndtjkpl.f[5]++;
        cov_247ndtjkpl.s[11]++;

        _get(_getPrototypeOf(Hidable.prototype), "componentDidMount", this).call(this);

        var el = (cov_247ndtjkpl.s[12]++, this.getElement());
        cov_247ndtjkpl.s[13]++;

        if (!el) {
          cov_247ndtjkpl.b[3][0]++;
          cov_247ndtjkpl.s[14]++;
          return;
        } else {
          cov_247ndtjkpl.b[3][1]++;
        }

        cov_247ndtjkpl.s[15]++;

        if (hasCollapse) {
          cov_247ndtjkpl.b[4][0]++;
          cov_247ndtjkpl.s[16]++;
          this.height = el.offsetHeight;
        } else {
          cov_247ndtjkpl.b[4][1]++;
        }

        cov_247ndtjkpl.s[17]++;

        if (this.props.show) {
          cov_247ndtjkpl.b[5][0]++;
          cov_247ndtjkpl.s[18]++;
          this.show();
          cov_247ndtjkpl.s[19]++;
          return;
        } else {
          cov_247ndtjkpl.b[5][1]++;
        }

        cov_247ndtjkpl.s[20]++;
        el.style.display = 'none';
        cov_247ndtjkpl.s[21]++;

        if (hasCollapse) {
          cov_247ndtjkpl.b[6][0]++;
          cov_247ndtjkpl.s[22]++;
          el.style.overflow = 'hidden';
          cov_247ndtjkpl.s[23]++;
          el.style.height = '0px';
        } else {
          cov_247ndtjkpl.b[6][1]++;
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        cov_247ndtjkpl.f[6]++;
        cov_247ndtjkpl.s[24]++;

        if (this.props.show === prevProps.show) {
          cov_247ndtjkpl.b[7][0]++;
          cov_247ndtjkpl.s[25]++;
          return;
        } else {
          cov_247ndtjkpl.b[7][1]++;
        }

        cov_247ndtjkpl.s[26]++;

        if (this.props.show) {
          cov_247ndtjkpl.b[8][0]++;
          cov_247ndtjkpl.s[27]++;
          this.show();
        } else {
          cov_247ndtjkpl.b[8][1]++;
          cov_247ndtjkpl.s[28]++;
          this.hide();
        }
      }
    }, {
      key: "getElement",
      value: function getElement() {
        cov_247ndtjkpl.f[7]++;
        cov_247ndtjkpl.s[29]++;
        return document.querySelector(".".concat(this.id));
      }
    }, {
      key: "show",
      value: function show() {
        var _this3 = this;

        cov_247ndtjkpl.f[8]++;
        var es = (cov_247ndtjkpl.s[30]++, this.getElement().style);
        cov_247ndtjkpl.s[31]++;
        es.display = display;
        cov_247ndtjkpl.s[32]++;
        setTimeout(function () {
          cov_247ndtjkpl.f[9]++;
          cov_247ndtjkpl.s[33]++;

          if (_this3.$isMounted) {
            cov_247ndtjkpl.b[9][0]++;
            cov_247ndtjkpl.s[34]++;

            _this3.setState({
              show: true
            });

            cov_247ndtjkpl.s[35]++;

            if (hasCollapse) {
              cov_247ndtjkpl.b[10][0]++;
              cov_247ndtjkpl.s[36]++;
              es.height = "".concat(_this3.height, "px");
              cov_247ndtjkpl.s[37]++;
              setTimeout(function () {
                cov_247ndtjkpl.f[10]++;
                cov_247ndtjkpl.s[38]++;
                es.height = 'auto';
                cov_247ndtjkpl.s[39]++;
                es.overflow = '';
              }, duration);
            } else {
              cov_247ndtjkpl.b[10][1]++;
            }
          } else {
            cov_247ndtjkpl.b[9][1]++;
          }
        }, 10);
      }
    }, {
      key: "hide",
      value: function hide() {
        var _this4 = this;

        cov_247ndtjkpl.f[11]++;
        cov_247ndtjkpl.s[40]++;
        this.setState({
          show: false
        });
        var element = (cov_247ndtjkpl.s[41]++, this.getElement());
        cov_247ndtjkpl.s[42]++;

        if (hasCollapse) {
          cov_247ndtjkpl.b[11][0]++;
          cov_247ndtjkpl.s[43]++;
          this.height = element.offsetHeight;
          cov_247ndtjkpl.s[44]++;
          element.style.height = "".concat(this.height, "px");
          cov_247ndtjkpl.s[45]++;
          element.style.overflow = 'hidden';
          cov_247ndtjkpl.s[46]++;
          setTimeout(function () {
            cov_247ndtjkpl.f[12]++;
            cov_247ndtjkpl.s[47]++;
            element.style.height = '0px';
          }, 10);
        } else {
          cov_247ndtjkpl.b[11][1]++;
        }

        cov_247ndtjkpl.s[48]++;
        setTimeout(function () {
          cov_247ndtjkpl.f[13]++;
          cov_247ndtjkpl.s[49]++;

          if ((cov_247ndtjkpl.b[13][0]++, _this4.state.show === false) && (cov_247ndtjkpl.b[13][1]++, element)) {
            cov_247ndtjkpl.b[12][0]++;
            cov_247ndtjkpl.s[50]++;
            element.style.display = 'none';
          } else {
            cov_247ndtjkpl.b[12][1]++;
          }
        }, duration);
      }
    }, {
      key: "render",
      value: function render() {
        cov_247ndtjkpl.f[14]++;
        var animation = (cov_247ndtjkpl.s[51]++, "animation-".concat(duration));
        cov_247ndtjkpl.s[52]++;

        if (!needTransform) {
          cov_247ndtjkpl.b[14][0]++;
          cov_247ndtjkpl.s[53]++;
          animation = "fade-".concat(animation);
        } else {
          cov_247ndtjkpl.b[14][1]++;
        }

        var className = (cov_247ndtjkpl.s[54]++, classnames(hidableClass.apply(void 0, ['_'].concat(_toConsumableArray(type), [animation, (cov_247ndtjkpl.b[15][0]++, this.state.show) && (cov_247ndtjkpl.b[15][1]++, 'show')])), this.props.className, this.id));
        var provider = (cov_247ndtjkpl.s[55]++, {
          visible: this.state.show
        });
        cov_247ndtjkpl.s[56]++;
        return (
          /*#__PURE__*/
          React.createElement(context.Provider, {
            value: provider,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 145,
              columnNumber: 9
            }
          },
          /*#__PURE__*/
          React.createElement(Component, Object.assign({}, this.props, {
            className: className,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 146,
              columnNumber: 11
            }
          })))
        );
      }
    }]);

    return Hidable;
  }(PureComponent);

  Hidable.defaultProps = {
    className: '',
    show: false
  };
  cov_247ndtjkpl.s[57]++;
  return Hidable;
}